import { LocalDate, ZoneId } from "@js-joda/core";
import { format } from "date-fns";

export const formatDateToLocalString = (date: Date | number | string) =>
  format(date, "dd/MM/yyyy");

export const formatCurrency = (amount: number) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(amount);

export const formatCurrencyFromPence = (amountPence: number) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amountPence / 100);

export const poundsToPence = (amountPounds: number) =>
  Math.round(amountPounds * 100);

export const penceToPounds = (amountPence: number) => amountPence / 100;

export const localDateToJSDate = (localDate: LocalDate): Date => {
  return new Date(
    localDate.atStartOfDay(ZoneId.systemDefault()).toInstant().toEpochMilli()
  );
};
